import { GenericUploadTranslations } from './generic-upload-translations.interface';

/**
 * German translations for Generic Upload Component
 */
export const GERMAN_GENERIC_UPLOAD_TRANSLATIONS: GenericUploadTranslations = {
  buttons: {
    select: 'Auswählen',
    retry: 'Wiederholen',
    remove: 'Entfernen'
  },
  labels: {
    dropFilesHere: 'oder Datei hier ablegen',
    allowedTypes: 'Erlaubte Dateitypen',
    maxSize: 'Maximale Größe',
    selectFiles: 'Dateien auswählen',
    dropZone: 'Datei-Upload Bereich - Klicken zum Auswählen oder Dateien per Drag & Drop ablegen',
    uploadedFiles: 'Hochgeladene Dateien',
    uploadProgress: 'Upload-Fortschritt'
  },
  states: {
    pending: 'Ausstehend',
    uploading: 'Upload läuft',
    completed: 'Upload abgeschlossen',
    failed: 'Upload fehlgeschlagen'
  },
  errors: {
    fileTypeNotAllowed: 'Dateityp {extension} ist nicht erlaubt. Erlaubte Typen: {allowedTypes}',
    fileTooSmall: 'Datei ist zu klein. Mindestgröße: {minSize}',
    fileTooLarge: 'Datei ist zu groß. Maximale Größe: {maxSize}',
    uploadFailed: 'Upload fehlgeschlagen'
  },
  units: {
    bytes: 'Bytes',
    kb: 'KB',
    mb: 'MB',
    gb: 'GB'
  }
};
